import { ref } from "vue";

import type { ProductDefinition } from "@/types/products/product-definitions";
import { sssHistoryKey, sssProductKey, sssScannerKey, sssScannerTabKey } from "@/types/products/product-definitions";
import { configureProductActionsMap } from "@/composables/products/product-composition-helpers";

// Non-reactive variables. `selectedView` is a module singleton like every other
// product composable (see dark-money-indicator.ts) so ProductWorkspace's sync
// comment there applies here too.
const initialView: string = sssScannerTabKey;
const selectedView = ref< string >( initialView );

const productActionTopicKeys = [
    sssScannerKey,
    sssHistoryKey
];

export function useShadowSpikeScanner(): ProductDefinition {
    // SSS is not in the CMS product catalog, so initializeProduct() (which looks the
    // slug up in useProductsStore) is deliberately NOT called: it would never
    // resolve a logo and `initialized` would stay false forever. There is no logo
    // asset yet either — `title` makes ProductWorkspace render an <h1> instead.
    const initialized = ref< boolean >( true );
    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( sssProductKey, productActionTopicKeys );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        selectedView,
        title: 'Shadow Spike Scanner'
    }
}
